import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SplashscreenComponent } from '@pages/splashscreen/splashscreen.component';
import { AuthGuard } from '@guards/authentication.guard';
import { SplashGuard } from '@guards/splashScreen.guard';
import { LayoutComponent } from './layouts/layout/layout.component';
import { AppCallbackComponent } from '@components/callback/callback.component';
import { LoginComponent } from '@pages/login/login.component';
import { CookiesComponent } from '@pages/cookies/cookies.component';
import { SpainGuard } from '@guards/spain.guard';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'splash',
    },
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: 'home',
                loadChildren: () => import('@pages/home/home.module').then(m => m.HomeModule),
                canActivate: [AuthGuard],
                data: {
                    title: 'Inicio',
                },
            },
            {
                path: 'markets',
                loadChildren: () => import('@pages/mercados/mercados.module').then(m => m.MercadosModule),
                canActivate: [AuthGuard],
                data: {
                    title: 'Mercados',
                },
            },
            {
                path: 'favorites',
                loadChildren: () => import('@pages/favoritos/favoritos.module').then(m => m.FavoritosModule),
                canActivate: [AuthGuard],
                data: {
                    title: 'Favoritos',
                },
            },
            {
                path: 'manageAlerts',
                loadChildren: () => import('@pages/gerir-alertas/gerir-alertas.module').then(m => m.GerirAlertasModule),
                canActivate: [AuthGuard],
                data: {
                    title: 'Alertas',
                },
            },
            {
                path: 'signalings',
                loadChildren: () => import('@pages/sinalizacoes/sinalizacoes.module').then(m => m.SinalizacoesModule),
                canActivate: [AuthGuard],
                data: {
                    title: 'Sinalizações',
                },
            },
        ],
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'splash',
        component: SplashscreenComponent,
        canActivate: [SplashGuard],
    },
    {
        path: 'callback',
        component: AppCallbackComponent,
    },
    {
        path: 'cookies',
        component: CookiesComponent,
        canActivate: [SpainGuard],
    },
    {
        path: '**',
        redirectTo: 'home',
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
